import { createStyles, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            [theme.breakpoints.up("md")]: {
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(2),
            },
            [theme.breakpoints.up("lg")]: {
                marginBottom: theme.spacing(3),
            },
        },
    })
);

export default useStyles;
